import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
import { G_API } from '../../constants/globalVar';
import ReactGA from 'react-ga4';
import SocialShareButtons from "../Button/SocialShareButtons";
import Table from 'react-bootstrap/Table';

export default function DetailPage(){
    const { id } = useParams();
    const [item, setItem] = useState(null);
    const [formattedDate, setFormattedDate] = useState('');
    const [formattedTime, setFormattedTime] = useState('');
    useEffect(() => {
        var data = '';
        var config = {
            method: 'POST',
            maxBodyLength: Infinity,
            url: `${G_API}events/EVENT_LIST?id=${id}`,
            headers: { },
            data : data
        };

        axios(config)
        .then( (response) => {
            const item = response.data.DATAS;
            setItem(item);
            setFormattedDate(item.event_date.substring(0, 10));
            // const event_time = new Date(item.event_time);
            let tempformatDate = (event_time) => {
              const date = new Date(event_time);
              const formattedTime = date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
              const parts = formattedTime.split(' ');
              const formattedString = `${parts[0]} ${parts[1]}`;
              return formattedString;
            }
            const formattedTime = tempformatDate(item.event_time);
            setFormattedTime(formattedTime);
        })
        .catch(function (error) {
            console.error(error);
        });
    }, [id]);

    const isRegistrationLinkValid = item && item.registeration_link &&
                                   item.registeration_link !== 'N/A' &&
                                   item.registeration_link !== 'NA' &&
                                   item.registeration_link !== '-';

    const isZoomLinkValid = item && item.zoom_link &&
                                   item.zoom_link !== 'N/A' &&
                                   item.zoom_link !== 'NA' &&
                                   item.zoom_link !== '-';
    function openZoom(event) {
        if (!isZoomLinkValid) {
            event.preventDefault();
        }
    }

    function openShare() {
        ReactGA.event({
            category: 'Event',
            action: 'event_share_btn_clicked',
            label: item ? item.title : 'Event Share',
        });
    }

    function openRegister(event) {
        if (!isRegistrationLinkValid) {
            event.preventDefault();
        }

        ReactGA.event({
            category: 'Event',
            action: 'event_register_btn_clicked',
            label: item ? item.title : 'Event Register',
        });
    }

    return (
        <>
        {item ? (
          <div>
            <div id="header-carousel" className="carousel slide" data-bs-ride="carousel" >
                <div className="carousel-inner" >
                    <div className="carousel-item active">
                        {item.cover_img?.src ? (
                            <img className="w-100 small-slider" src={item.cover_img.src} alt="" />
                        ): (
                            <img className="w-100 small-slider" src='/assets/img9.jpg' alt="" />
                        )}
                        <div className="carousel-caption">
                            <div className="container">
                                <div className="row justify-content-center">
                                    <div className="col-lg-7 pt-0">
                                        <h1 className="display-4 text-white mb-1 mt-2 pt-2 animated slideInDown">
                                            {item.title}
                                        </h1>
                                        <p className="fs-5 text-white-50 mb-5 animated slideInDown">We make free online courses, information sharing events, and volunteer
work for community development</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="container my-4">
                  <div className="row">
                    <div className="col-sm-12 col-md-6 my-4">
                      <div className="px-4 py-4">
                        <h2 className="mb-4">{item.title}</h2>
                        <h4 className="mb-2">by {item.presented_by}</h4>
                        <h6 className="mb-4 text-muted">Organized by {item.organized_by}</h6>
                        <p>
                        <span
                          dangerouslySetInnerHTML={{ __html: item.description }}
                        />
                      </p>
                      </div>
                      <div className="switchBtn d-flex justify-content-between px-4 py-4">
                        <div>
                            {isRegistrationLinkValid ? (
                                <a className="regBtn" onClick={openRegister} href={item.registeration_link} disabled={!item.registeration_link} target="_blank" rel="noreferrer">Register Here</a>
                            ) : (
                                <button type="button" className="regBtn">Register Closed</button>
                            )}
                        </div>
                        <div>
                            <SocialShareButtons title={item.title} onClick={openShare} />
                        </div>
                      </div>

                        <div>
                            <span className="opacity-50">Tags: </span>
                            <span>
                            {((item.tags !== undefined) ? item.tags.map((tag, index) => (
                                <a key={index} className="badge bg-secondary me-1 text-decoration-none" href={tag.title ? `/events/tags/${tag.title}` : "#"}>
                                    {tag.title}
                                </a>
                            )) : null)}
                            </span>
                        </div>
                    </div>

                    <div className="col-sm-12 col-md-6 my-4">
                      <div className="text-center">
                        {item.feature_img?.src ? (
                        <img className="event-img" src={item.feature_img.src} alt="" style={{ objectFit:'cover',width:'100%' ,minHeight:'500px', height:'auto' }}/>
                        ): (
                        <img className="event-img" src='/assets/images/BlogTemp.png' alt="" style={{ objectFit:'cover',width:'100%' ,minHeight:'500px', height:'auto' }}/>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="table-responsive">
                <Table responsive className="custom-table text-center align-middle">
                    <thead>
                    <tr style={{ borderBottom: "2px solid #ec711e" }}>
                        <th className="text-muted fw-normal py-3">Date</th>
                        <th className="text-muted fw-normal py-3">Time</th>
                        <th className="text-muted fw-normal py-3">Platform</th>
                        <th className="text-muted fw-normal py-3">Language</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td className="fw-bold py-3">
                        {item.event_date ? formattedDate : "Coming soon..."}
                        </td>

                        <td className="fw-bold py-3">
                        {item.event_time ? formattedTime : "Coming soon..."}
                        </td>

                        <td className="fw-bold py-3">
                        {item.event_platform ? (
                            isZoomLinkValid ? (
                            <a 
                                className="shareBtn" 
                                onClick={openZoom} 
                                href={item.zoom_link} 
                                style={{ textDecoration: 'none' }}
                            >
                                {item.event_platform}
                            </a>
                            ) : (
                            <span className="shareBtn text-muted">No Zoom Link</span>
                            )
                        ) : (
                            "Coming soon..."
                        )}
                        </td>

                        <td className="fw-bold py-3">
                        {item.languages && item.languages.length > 0 ? item.languages[0] : "Coming soon..."}
                        </td>
                    </tr>
                    </tbody>
                </Table>
                </div>
              </div>
            </div>
            ) : <div>
                <span>Loading...</span>
            </div> }
        </>
    );
}
